// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FunTagList_wrapper__2viqd","list":"FunTagList_list__2GhdP","list__item":"FunTagList_list__item__37Ncl"};